import { merge } from 'lodash';

/* eslint-disable no-unused-vars */

const initialState = {
  client: {
    name: 'All Clients',
    code: '',
    selected: 0,
    listVisible: false,
  },
  searchTerm: '',
  itemsDisplayed: 0,
  itemsSelected: {
    total: 0,
    list: [],
    statusChanges: 0,
    seriesChanges: 0,
    categoryChanges: 0,
  },
  needsReloading: false,
  tab: 'status-changes',
};

const actions = {
  setPendingClient: {
    root: true,
    handler({ commit, state }, payload) {
      commit('updatePendingClient', payload);
    },
  },
  setPendingClientName: {
    root: true,
    handler({ commit, state }, name) {
      commit('updatePendingClientName', name);
    },
  },
  setPendingClientSelected: {
    root: true,
    handler({ commit, state }, selected) {
      commit('updatePendingClientSelected', selected);
    },
  },
  setPendingClientListVisible: {
    root: true,
    handler({ commit, state }, visible) {
      commit('updatePendingClientListVisible', visible);
    },
  },
  setPendingSearchTerm: {
    root: true,
    handler({ commit, state }, term) {
      commit('updatePendingSearchTerm', term);
    },
  },
  setPendingItemsDisplayed: {
    root: true,
    handler({ commit, state }, payload) {
      commit('updatePendingItemsDisplayed', payload);
    },
  },
  setPendingItemsSelected: {
    root: true,
    handler({ commit, state }, number) {
      commit('updatePendingItemsSelected', number);
    },
  },
  setReloadNeed: {
    root: true,
    handler({ commit, state }, value) {
      commit('updateNeedReload', value);
    },
  },
  setPendingTab: {
    root: true,
    handler({ commit, state }, selected) {
      commit('updatePendingTab', selected);
    },
  },
};

const mutations = {
  updatePendingClient(state, payload) {
    state.client = merge(state.client, payload);
  },
  updatePendingClientName(state, name) {
    state.client.name = name;
  },
  updatePendingClientSelected(state, selected) {
    state.client.selected = selected;
  },
  updatePendingClientListVisible(state, visible) {
    state.client.listVisible = visible;
  },
  updatePendingSearchTerm(state, term) {
    state.searchTerm = term;
  },
  updatePendingItemsDisplayed(state, number) {
    state.itemsDisplayed = number;
  },
  updatePendingItemsSelected(state, payload) {
    const defaultData = {
      list: [],
      statusChangesList: [],
      seriesChangesList: [],
      total: 0,
    };
    const {
      list = [],
      total = 0,
      statusChangesList = [],
      seriesChangesList = [],
      statusChanges = 0,
      seriesChanges = 0,
      categoryChanges = 0,
    } = payload || defaultData;

    state.itemsSelected = {
      list,
      total,
      statusChanges,
      seriesChanges,
      categoryChanges,
      statusChangesList,
      seriesChangesList,
    };
  },
  updateNeedReload(state, value) {
    state.needsReloading = value;
  },
  updatePendingTab(state, selected) {
    state.tab = selected;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
